import { render, staticRenderFns } from "./loanform.vue?vue&type=template&id=510f08bb&"
import script from "./loanform.vue?vue&type=script&lang=js&"
export * from "./loanform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports